import {APP_NAME} from "settings/index";

export function getLocalStorageKey(key: string) {
    return `${APP_NAME}_${key}`;
}
export const JWT_LS_KEY = getLocalStorageKey('jwt');
export const REMEMBER_LOGIN_LS_KEY = getLocalStorageKey('remember_login_username');
